/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ prompt: NonNullable<unknown> }} Chat_Image_Viewer_Regenerate_MessageInputs */



/**
* | output |
* | --- |
* | "Please regenerate the image with this prompt: {prompt}" |
*
* @param {Chat_Image_Viewer_Regenerate_MessageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_image_viewer_regenerate_message = /** @type {((inputs: Chat_Image_Viewer_Regenerate_MessageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Image_Viewer_Regenerate_MessageInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Bitte erzeuge das Bild neu mit diesem Prompt: ${i?.prompt}`)
	return /** @type {LocalizedString} */ (`Please regenerate the image with this prompt: ${i?.prompt}`)
});